import { Assert } from "../../Assert";
import { PartialNullable } from "../../Extensions";
import { PropertyChange } from "../../PropertyChange";
import { Property, PropertyString } from "../../RadObject";
import { IPropertyEditor, PropertyEditor, PropertyEditorPropertyValues } from "../Controls/PropertyEditor";
import { TextApplicationEntity } from "./TextApplicationEntity";
import { NAMESPACE } from "./_Namespace";

export type PropertyEditorTextApplicationEntityPropertyValues =
    PropertyEditorPropertyValues
    & {
        primaryEntity: string;
        primaryEntityDescriptionProperty: string;
    };

export type PropertyEditorTextApplicationEntityProperties = {
    [name in keyof PropertyEditorTextApplicationEntityPropertyValues]: Property<PropertyEditorTextApplicationEntityPropertyValues[name]>
};

export interface IPropertyEditorTextApplicationEntity extends IPropertyEditor, PropertyEditorTextApplicationEntityProperties
{
}

export class PropertyEditorTextApplicationEntity extends PropertyEditor implements IPropertyEditorTextApplicationEntity
{
    // #region Static

    public static override classNamespace = NAMESPACE + "PropertyEditorTextApplicationEntity";
    public static override className = "PropertyEditorTextApplicationEntity";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<PropertyEditorTextApplicationEntityPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                createEditorControl: () => new TextApplicationEntity(),
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Properties

    public primaryEntity!: PropertyString;
    public primaryEntityDescriptionProperty!: PropertyString;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<PropertyEditorTextApplicationEntityPropertyValues>)
    {
        super(propertyValues);

        // Trigger Property Changes
        this.primaryEntity.triggerChange();
        this.primaryEntityDescriptionProperty.triggerChange();
    }

    // #endregion

    // #region Protected Methods

    protected _primaryEntityChanged(change: PropertyChange<string>)
    {
        const
            editorControl = this.editorControl.get();

        Assert.isInstanceOf(TextApplicationEntity, editorControl, "editorControl");

        editorControl.primaryEntity.set(change.currentValue);
    }
    protected _primaryEntityDescriptionPropertyChanged(change: PropertyChange<string>)
    {
        const
            editorControl = this.editorControl.get();

        Assert.isInstanceOf(TextApplicationEntity, editorControl, "editorControl");

        editorControl.primaryEntityDescriptionProperty.set(change.currentValue);
    }

    // #endregion

    // #region Overrides

    protected override __initializeProperties(propertyValues: PropertyEditorTextApplicationEntityPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this.primaryEntity = new PropertyString(this, propertyValues.primaryEntity, this._primaryEntityChanged);
        this.primaryEntityDescriptionProperty = new PropertyString(this, propertyValues.primaryEntityDescriptionProperty, this._primaryEntityDescriptionPropertyChanged);
    }

    public override loadDataAsync()
    {
        const
            editorControl = this.editorControl.get();

        Assert.isInstanceOf(TextApplicationEntity, editorControl, "editorControl");

        return editorControl.loadDataAsync();
    }

    // #endregion

    // #endregion
}
